import { Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export abstract class Collapsible {
    @Output() public elementSizeModification = new EventEmitter<void>();

    public isCollapsed = false;

    public toggleCollapsed(): void {
        this.isCollapsed = !this.isCollapsed;
        setTimeout(() => {
            this.elementSizeModification.emit();
        }, 0);
    }
}
